import React from 'react';
import { CATALOG_ICONS } from '../components/ui/IconPicker.js';
import { Package } from 'lucide-react';

export function renderCatalogIcon(iconName: string | null | undefined, size = 18) {
  const found = CATALOG_ICONS.find(i => i.name === iconName);
  const Icon = found?.Icon ?? Package;
  return <Icon size={size} />;
}
